export const SET_COLLECTIONS = 'SET_COLLECTIONS';
